import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ResizeHandleComponent } from './resize-handle.component'

@NgModule({
  imports: [CommonModule],
  declarations: [ResizeHandleComponent],
  exports: [ResizeHandleComponent],
})
export class ResizeHandleModule {}
